const LiquidWasteContent = [
  {
    title: "Introduction",
    description: `
      Liquid waste—comprising domestic wastewater, grey water, industrial effluents, and sludge—poses a major challenge 
      to environmental health and public safety, especially in rapidly growing urban and rural areas. 
      Improper disposal contaminates water sources, spreads diseases, and degrades ecosystems. 
      The Liquid Waste Management Programme aims to establish sustainable, safe, and affordable systems for the collection, 
      treatment, reuse, and disposal of liquid waste in accordance with national sanitation policies and environmental standards.
    `,
    objectives: [
      "To improve public health and environmental quality through the effective management of liquid waste in [target area].",
      "To develop decentralized and affordable wastewater and sludge treatment systems.",
      "To strengthen institutional capacity for liquid waste management.",
      "To promote safe reuse of treated wastewater and sludge for agriculture or landscaping.",
      "To raise public awareness and community participation in proper waste disposal.",
      "To establish monitoring systems to ensure compliance with national and international standards.",
    ],
    outcomes: [
      "Reduction in untreated wastewater discharge.",
      "Improved public health indicators (e.g., reduction in waterborne diseases).",
      "Increased reuse of treated wastewater for agriculture and landscaping.",
      "Strengthened institutional capacity and community engagement.",
      "Compliance with environmental and sanitation standards.",
    ],
  },
  {
    title: "Implementation Approach",
    description: `
      The programme will adopt a multi-stakeholder approach involving various sectors and communities to ensure 
      sustainability and efficiency in liquid waste management.
    `,
    objectives: [
      "Local governments – policy enforcement and infrastructure support.",
      "Private sector – operation and maintenance of facilities.",
      "Communities – participation in collection, segregation, and awareness activities.",
      "Development partners / NGOs – technical and financial assistance.",
    ],
  },
  {
    title: "Sustainability Measures",
    description: `
      The programme ensures long-term sustainability through financial, institutional, and community-based mechanisms.
    `,
    objectives: [
      "Cost recovery through user fees and reuse of treated wastewater.",
      "Integration with local government sanitation plans.",
      "Continuous training and institutional strengthening.",
      "Public–Private Partnerships for Operation & Maintenance (O&M).",
    ],
  },
  {
    title: "Major Activities",
    description: `
      Various infrastructure and technology-based interventions will be implemented for efficient liquid waste management.
    `,
    activities: [
      {
        title: "Construction of Soak Pits, Leach Pits, and Magic Pits",
        objectives: [
          "Develop decentralized soakage and leach pit systems for effective percolation and treatment of greywater in rural areas.",
        ],
        images: [
          "/assets/img/24.jpg",
          "/assets/img/25.jpg",
          "/assets/img/26.jpg",
        ],
      },
      {
        title: "Installation of Sewage Treatment Plant (STP) – Johkasou Model",
        objectives: [
          "Implementation of decentralized sewage treatment systems using the Johkasou model to efficiently treat wastewater at the source.",
        ],
        images: [
          "/assets/img/27.jpg",
          "/assets/img/28.jpg",
          "/assets/img/29.jpg",
        ],
      },
      {
        title: "Deployment of Mobile Septage Treatment Units",
        objectives: [
          "Mobile septage treatment units to manage and treat liquid waste effectively in both urban and rural environments.",
        ],
      },
    ],
  },
];

export default LiquidWasteContent;
